import { createAction } from 'redux-actions'

export const SET_MEDIA: any = createAction('SET_MEDIA');